import { addons } from '@storybook/addons';
import theme from './wiley-flint-sb-theme';

addons.setConfig({
  theme,
});
